import { CHAT_WITH_US } from 'shared/constants/uri';

export const TEXTS = {
  SHIP_TO_COUNTRY: 'Ship to Country:',
  SHOP_IN_CURRENCY: 'Shop in Currency:',
  TERMS_CONDITION: 'Terms & Conditions',
  SHIPPING_RETURN: 'Shipping & Return Policy',
  IN_POLICY: 'Privacy Policy',
  EU_POLICY: 'Privacy Policy For EU Residents',
  HELP_CENTER: 'Help Center',
  MY_ORDERS: 'My Orders',
  MY_WISHLIST: 'My Wishlist',
  LOGOUT: 'Logout',
  SIGN_IN: 'Sign in / Register',
  DOWNLOAD_APP: 'Download Our App',
  GOOGLE_PLAY: 'Google Play',
  APPLE_STORE: 'Apple Store',
  RESPONSIBLE_DISCLOSURE: 'Responsible Disclosure',
  ABOUT_US: 'About Us',
  CHAT_WITH_US: 'Chat with us',
  PROFILE: 'Profile Settings',
};

export const LINKS = {
  HELP_CENTER_NON_PROD:
    'https://preprod.nykaafashion.com/gateway-api/omsApis/helpCenter?domain=NYKAA_FASHION',
  HELP_CENTER_PROD:
    'https://www.nykaafashion.com/gateway-api/omsApis/helpCenter?domain=NYKAA_FASHION',
  ABOUT_US: '/lp/about-us',
  SHIPPING_RETURN: '/shipping-and-return-policy.html?root=footer',
  IN_POLICY: '/lp/privacy-policy-india',
  EU_POLICY: '/privacy-policy.html',
  TERMS_CONDITION: '/terms-and-conditions.html?root=footer',
  MY_ORDERS: '/sales/order/history',
  MY_WISHLIST: '/wishlist',
  LOGOUT: '/customer/account/logout',
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.fsn.nds',
  APP_STORE: 'https://itunes.apple.com/in/app/nykaa-design-studio/id1439872423?mt=8',
  RESPONSIBLE_DISCLOSURE: '/responsible-disclosure',
  CHAT_WITH_US,
  MY_PROFILE: '/my-profile',
};

export const IMAGES = {
  GOOGLE_PLAY: '/pub/static/frontend/Nykaa/theme001/en_US/images/glplay.png',
  APP_STORE: '/pub/static/frontend/Nykaa/theme001/en_US/images/appleStore.png',
};

export const MENU_PADDING = 10;
